// ******************************************************************************************** Clean a String (Removes Accents), return Lowercase
export function lbSimplify(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

// ******************************************************************************************** // Show Debug Messages if it is enabled
export async function debugLog(functionName, message) { 
  const { debug } = await import("./exports/debug.js"); 
  if (debug) console.log(functionName + "-->", message) 
} 

// ************************************************************* Return a copy of the object
export function copyObj(objectToCopy) {
    return JSON.parse(JSON.stringify(objectToCopy));
}

// ******************************************************************************************** Toggles elements in the UI
export function lbToggler(mode,element, value1, value2) {
    if(mode=="text")  {
      if ($("#" + element).text() == value1)
        $("#" + element).text(value2);
      else
        $("#" + element).text(value1);
    }
    if(mode=="type")  {
      if ($("#" + element).attr("type") === value1)
        $("#" + element).attr("type", value2);
      else
        $("#" + element).attr("type", value1);
    } 
    if(mode=="class")  {
      if ($("#" + element).hasClass(value1))  {
        $("#" + element).removeClass(value1);
        $("#" + element).addClass(value2);
      }
        
      else  {
        $("#" + element).removeClass(value2);
        $("#" + element).addClass(value1);
      }
    }   
}

// ******************************************************************************************** Verifies if a text is an email
export function lbIsEmail(email) {

  // -- Modificación sugerida por ESLINT --  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

// ******************************************************************************************** Generates a unique ID
export function makeID(length) {
let result = "";
const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const charactersLength = characters.length;
let counter = 0;
while (counter < length) {
  result += characters.charAt(Math.floor(Math.random() * charactersLength));
  counter += 1;
}
return result;
}

// ******************************************************************************************** Convert ms + ns format to string data format
export function convTimestampToDate(dateTimestamp, showTime) {
  let date = new Date(dateTimestamp["seconds"]*1000 + dateTimestamp["nanoseconds"]/1e6);
  if (showTime) return date.toLocaleString("en-GB");
  else          return date.toLocaleDateString("en-GB");
}

// ******************************************************************************************** Calculates the number of days between today and a future date
export function calculateDays(futureDate) { // Future date is a string with format DD/MM/YYYY
let date1 = new Date(); 
let date2 = new Date(futureDate.split("/")[2], futureDate.split("/")[1] - 1, futureDate.split("/")[0]);
let utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());    // Convert dates to UTC timestamps
let utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
let timeDiff = Math.abs(utc2 - utc1);                                           // Calculate the time difference in milliseconds
let daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));                     // Convert milliseconds to days
return  daysDiff;
}

// ************************************************************* Returns an array with the keys ordered (criteria: values ordered alphabetically)
export function sortKeysInObjByValues(objectToSort) {
  let auxOrderArray = [];
  for (let key in objectToSort) { auxOrderArray.push([objectToSort[key], key]) }
  return auxOrderArray.sort((a, b) => String(a[0]).localeCompare(String(b[0]))).map(([_value, key]) => key);
}

// ***************************** Sorts an object alphabetically by a given property and returns an array containing the keys of the objectToSort sorted
export function sortKeysInObjByProp(objectToSort, propertyName) {
    let auxOrderArray = [];
    let orderArray = [];
    for(let key in objectToSort)
      // eslint-disable-next-line security/detect-object-injection
      auxOrderArray.push([objectToSort[key][propertyName], key])
    auxOrderArray.sort().forEach(([_key, value]) => {orderArray.push(value)})
    return orderArray;    // Returns an array containing the keys of the objectToSort sorted
}

// ***************************** Sorts an object based on a timestamp property and returns an array containing the keys of the objectToSort sorted
export function sortKeysInObjByTimeProp(objectToSort, timePropertyName) {
  let auxOrderArray = [];
  for(let key in objectToSort)
    // eslint-disable-next-line security/detect-object-injection
    auxOrderArray.push([key, objectToSort[key][timePropertyName]])
  return auxOrderArray.sort((a, b) => {return a[1].toMillis() - b[1].toMillis()}).map(element => element[0]);
}

// ***************************** Sorts an object based on on the lenght of the 'propertyName'.
export function sortKeysInObjByPropLength(objectToSort, propertyName) {
  const keys = Object.keys(objectToSort);
  keys.sort((a, b) => {
    const propA = objectToSort[a][propertyName];
    const propB = objectToSort[b][propertyName];
    return propB.length - propA.length;
  });
  return keys;
}

// ******************************************************************************************** Sorts a 2D array based on the first column
export function sort2DArrayBy2ndCol(a, b) {
if (a[1] === b[1]) { return 0;}
else { return (a[1] < b[1]) ? -1 : 1; }
}

// ******************************************************************************************** Copy the basicInfo into the clipboard & shows a message
export async function copyBasicData(basicInfo, msg) {
  const { uiMessage } = await import("./exports/uiMessage.js");
  try {
      await navigator.clipboard.writeText(basicInfo);
      uiMessage({ "type": "snackbar", "text": msg });
  } catch (error) {
      uiMessage({ "type": "snackbar", "text": "No se pudo copiar la información. Error: " + error.message });
  }
} 

// ******************************************************************************************** Swaps 2 elements of an array
export function swapArrayElements(arrayToModify, fromIndex, toIndex) {
    const element = arrayToModify.splice(fromIndex, 1)[0]; 
    arrayToModify.splice(toIndex, 0, element); 
}

// ******************************************************************************************** Extracts & returns the name of a file from an URL
export function getFileName(url) {
  const parts = url.replace(/%2F/g, "/").split("?")[0].split("/");
  debugLog("getFileName", parts[parts.length - 1]);
  return parts[parts.length - 1];
}

// ******************************************************************************************** Sanitizes an input
export function sanitizeText(input) {
  if (typeof input !== "string") return "";
  return input.replace(/[^a-zA-Z0-9_-ñÑ]/g, "");
}

// ******************************************************************************************** Escapes HTML characters to avoid XSS attacks when inserting text to DOM
export function sanitizeHTML(input) {
  if (typeof input !== "string") return "";
  const map = {"&": "&amp;","<": "&lt;",">": "&gt;","\"": "&quot;","'": "&#039;","`": "&#x60;"};
  // La variable 'm' siempre será uno de los caracteres fijos ('&', '<', '>', '"', "'') definidos en la expresión regular y que son claves válidas 
  // en el objeto 'map'. No hay forma de que una entrada externa manipule 'm' para acceder a propiedades no deseadas.
  // eslint-disable-next-line security/detect-object-injection  
  return input.replace(/[&<>"'`]/g, (m) => map[m]).trim();
}

// ******************************************************************************************** Shares data to WhatsApp
export function shareInWhatsapp(shareData) {
  if (navigator.share) {
    navigator.share(shareData).then(() => {debugLog("shareInWhatsapp","Contenido compartido con éxito")}).catch((error) => {debugLog("shareInWhatsapp","Error al compartir", error)});
  } else {
    let whatsappAddress = "https://web.whatsapp.com/send?text=";
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))  whatsappAddress = "https://api.whatsapp.com/send?text=";    
    let whatsappText = "";
    if (shareData.title)  whatsappText += `${shareData.title}\n\n`;
    if (shareData.text)   whatsappText += `${shareData.text}\n`;
    if (shareData.url)    whatsappText += shareData.url;
    whatsappText.length > 0 ? window.open(whatsappAddress+`${encodeURIComponent(whatsappText)}`) : debugLog("shareInWhatsapp","No hay datos para compartir.");
  }
}

// ******************************************************************************************** Removes stop words from a list
export function removeStopWords(text) {
    const stopWords = new Set([
        'de', 'la', 'que', 'el', 'en', 'un', 'una', 'unos', 'unas', 'es', 'son', 'se',
        'su', 'sus', 'a', 'ante', 'bajo', 'con', 'contra', 'de', 'desde', 'durante',
        'en', 'entre', 'hacia', 'hasta', 'mediante', 'para', 'por', 'según', 'sin',
        'so', 'sobre', 'tras', 'o', 'u', 'y', 'e', 'si', 'no', 'mi', 'tu', 'te', 'me', 
        'mas', 'pero', 'como', 'cuando', 'donde', 'porque', 'mismo', 'este', 'esta',
        'estos', 'estas', 'ese', 'esa', 'esos', 'esas', 'uno', 'todo', 'todos', 'toda',
        'todas', 'cuyo', 'cuya', 'cuyos', 'cuyas', 'lo', 'al', 'del', 'les', 'le'
    ]);
    const words = text.toLowerCase().replace(/[.,!?:;¿¡]/g, '').trim().split(/\s+/);
    const filteredWords = words.filter(word => !stopWords.has(word));
    return filteredWords.join(' ');
}

// ************************************************************************************************************ Updates the preview for an specific price
export function lbCalcPriceVal(priceId, priceRefsSource, priceValuesSource) {
    const currentPriceRef = priceRefsSource[priceId];
    let priceValueToDisplay = null;
    const isLinked = currentPriceRef?.enableLink === true && currentPriceRef?.linkToPrice && priceRefsSource[currentPriceRef?.linkToPrice];
    const rawPriceSource = isLinked ? priceValuesSource[currentPriceRef.linkToPrice] : priceValuesSource[priceId];
    if (rawPriceSource !== undefined && rawPriceSource !== "") {
        let calculatedPrice = parseFloat(rawPriceSource);
        if (isLinked)   calculatedPrice = calculatedPrice * currentPriceRef.factor1 * currentPriceRef.factor2;
        if (!isNaN(calculatedPrice) && calculatedPrice > 0) priceValueToDisplay = calculatedPrice.toFixed(2);
    }
    return priceValueToDisplay;
}

// ******************************************************************************************** Get the contras color for the text in the themes
export function getContrastColor(hexColor) {
    const hex = hexColor.replace('#', '');
    const luminance = (0.2126 * parseInt(hex.substring(0, 2), 16) + 0.7152 * parseInt(hex.substring(2, 4), 16) + 0.0722 * parseInt(hex.substring(4, 6), 16)) / 255;
    return luminance > 0.5 ? 'black' : 'white';
}
// Exposes the function to be used in the app.html script
if (typeof window !== 'undefined') {  window.getContrastColor = getContrastColor; }

// ******************************************************************************************** Generates a unique and safe numeric Hash from a string
export function hash128(str) {
    let h = 1779033703 ^ str.length;
    for (let i = 0; i < str.length; i++) {
        h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
        h = (h << 13) | (h >>> 19);
    }
    return ((h ^ (h >>> 16)) >>> 0).toString();
}